import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Container, Box, Typography, useTheme, Drawer, IconButton, } from "@mui/material";
import { centered } from "@ui/style/style";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid2";
import { Icon } from "@iconify/react";
import { useTranslation } from "react-i18next";
import { HInput } from "@ui/components/inputs/HInput";
import { useForm } from "react-hook-form";
import { useAppDispatch, useAppSelector } from "@application/store/useStore";
import { PButton } from "@ui/components/buttons/PButton";
import { ArrowRight } from "iconsax-react";
import { HCheckbox } from "@ui/components/inputs/HCheckbox";
import { fetchAllCompaniesAsync } from "@application/features/company/companyThunk";
import { contactUsAsync } from "@application/features/contactUs/contactusThunk";
import { APIStatus } from "@application/common/enums/api-status";
import { toast } from "react-toastify";
import { HAutocomplete } from "@ui/components/inputs/HAutoComplete";
export const ContactUs = ({ open, onClose, onFAQOpen, }) => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const location = useLocation();
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const { allCompanies } = useAppSelector((state) => state.company);
    const { status, apiError } = useAppSelector((state) => state.contactUs);
    const { linkVerification } = useAppSelector((state) => state.event);
    const [eventType, setEventType] = useState("familyfest");
    useEffect(() => {
        if (location.pathname.includes("directors") ||
            location.pathname.includes("external")) {
            setEventType("relationsDay");
        }
        else {
            setEventType("familyfest");
        }
    }, [location, i18n.language]);
    const { control, handleSubmit, formState: { errors }, trigger, reset, watch, } = useForm({ mode: "onChange" });
    const onSubmit = async (data) => {
        try {
            if (linkVerification && linkVerification.data) {
                data.eventId = linkVerification.data.eventId;
            }
            await dispatch(contactUsAsync(data))
                .unwrap()
                .then((resp) => {
                if (resp && resp.isSuccess) {
                    toast.success(resp.message);
                    reset();
                    onClose();
                }
                else {
                    toast.error(resp.message);
                }
            });
        }
        catch (error) { }
    };
    useEffect(() => {
        dispatch(fetchAllCompaniesAsync());
    }, [navigate]);
    useEffect(() => {
        if (linkVerification?.data?.user) {
            const { user } = linkVerification.data;
            // Set default values
            reset({
                firstName: user.firstName || "",
                middleName: user.middleName || "",
                lastName: user.lastName || "",
                email: user.email || "",
                companyId: linkVerification.data.companyId || "",
                description: "",
                termsAccepted: false
            });
        }
    }, [linkVerification, reset]);
    const companyOptions = allCompanies?.map((company) => ({
        label: company.name,
        value: company.id,
    })) || [];
    const handleNext = async () => {
        const isValid = await trigger();
        if (!isValid)
            return;
    };
    return (_jsxs(Drawer, { anchor: "right", open: open, onClose: onClose, SlideProps: {
            timeout: 400, // custom animation duration
            easing: {
                enter: "cubic-bezier(0.4, 0, 0.2, 1)", // default MUI easing
                exit: "cubic-bezier(0.4, 0, 0.2, 1)",
            },
        }, PaperProps: {
            sx: {
                width: { xs: "80%", sm: 500 },
                borderTopLeftRadius: "24px",
                borderBottomLeftRadius: "24px",
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                overflow: "hidden",
                boxShadow: 3,
            },
        }, children: [_jsx(Box, { sx: { display: "flex", justifyContent: "flex-end", p: 1, pb: 1 }, children: _jsx(IconButton, { onClick: onClose, sx: {
                        width: { xs: 48, sm: 48, md: 64 },
                        height: { xs: 40, sm: 40, md: 48 },
                        border: "1px solid #00244D99",
                        color: "#00244D",
                        borderRadius: { xs: 1, sm: 1, md: 2 },
                    }, children: _jsx(Icon, { icon: "mdi:close", fontSize: 16 }) }) }), _jsx(Container, { sx: {
                    height: "calc(100svh - 25px)",
                    mb: "8px",
                    overflowY: "auto",
                }, children: _jsxs(Box, { sx: {
                        ...centered,
                        flexDirection: "column",
                        mb: 0,
                        gap: 0.4,
                        // height: "100%",
                    }, children: [_jsx(Typography, { mb: 1, fontSize: { xs: "20px", sm: "20px", md: "24px", lg: "28px" }, lineHeight: "100%", textAlign: "left", fontFamily: "Formula1", textTransform: "uppercase", color: theme.palette.primary.darker, sx: {
                                width: "100%",
                                textAlign: "left"
                            }, children: t("contactus.contactVDKGroup") }), _jsxs(Typography, { variant: "subtitle2", lineHeight: "16px", color: theme.palette.primary.darker, sx: {
                                display: "inline",
                            }, children: [t("contactus.contactSubheading", {
                                    eventType: t(`contactus.${eventType}`)
                                }), _jsx(Typography, { onClick: () => {
                                        onFAQOpen();
                                    }, sx: {
                                        textDecoration: "underline",
                                        cursor: "pointer",
                                        color: theme.palette.primary.light,
                                        display: "inline",
                                        ml: 0.5,
                                    }, children: t("contactus.faqLink") })] }), _jsx(Box, { sx: { alignSelf: "start", width: "100%" }, children: _jsx(Typography, { fontWeight: 500, textAlign: "left", fontSize: { xs: 16, sm: 16, md: 18, lg: 20 }, lineHeight: "160%", mt: 1, color: "#00244D", children: t("contactus.askYourQuestion") }) }), _jsxs(Grid, { mb: 1, container: true, spacing: 1, children: [_jsx(Grid, { size: { xs: 12, sm: 12 }, children: _jsx(HAutocomplete, { label: t("formFields.selectCompany"), name: "companyId", control: control, options: companyOptions, error: errors?.companyId?.message, rules: {
                                            required: {
                                                value: true,
                                                message: "validations.companyRequired",
                                            },
                                        } }) }), _jsx(Grid, { size: { xs: 12, sm: 12 }, children: _jsx(HInput, { label: t("formFields.firstName"), name: "firstName", control: control, error: errors?.firstName?.message, rules: {
                                            required: {
                                                value: true,
                                                message: "validations.firstNameRequired",
                                            },
                                        } }) }), _jsx(Grid, { size: { xs: 12, sm: 12 }, children: _jsx(HInput, { label: t("formFields.middleName"), name: "middleName", control: control }) }), _jsx(Grid, { size: { xs: 12, sm: 12 }, children: _jsx(HInput, { label: t("formFields.lastName"), name: "lastName", control: control, rules: {
                                            required: {
                                                value: true,
                                                message: "validations.lastNameRequired",
                                            },
                                        }, error: errors?.lastName?.message }) }), _jsx(Grid, { size: { xs: 12, sm: 12 }, children: _jsx(HInput, { label: t("formFields.email"), name: "email", control: control, rules: {
                                            required: {
                                                value: true,
                                                message: "validations.emailRequired",
                                            },
                                            pattern: {
                                                value: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/,
                                                message: t("validations.emailInvalid"),
                                            },
                                        }, error: errors?.email?.message }) }), _jsx(Grid, { size: 12, children: _jsx(HInput, { label: t("formFields.describeQuestion"), name: "description", control: control, rows: 3, multiLines: true, rules: {
                                            required: {
                                                value: true,
                                                message: "validations.descriptionRequired",
                                            },
                                        }, error: errors?.description?.message }) }), _jsx(Grid, { size: 12, children: _jsx(HCheckbox, { control: control, name: "termsAccepted", errormsg: errors?.termsAccepted?.message, rules: {
                                            required: {
                                                value: true,
                                                message: "validations.termsAndConditionsRequired",
                                            },
                                        }, label: _jsxs(_Fragment, { children: [t("formFields.iagreeTerms"), " ", _jsx("span", { style: {
                                                        textDecoration: "underline",
                                                        cursor: "pointer",
                                                        color: "blue",
                                                    }, 
                                                    // onClick={getPrivacyDocUrl}
                                                    onClick: () => window.open("/assets/privacy_document/PRIVACYVERKLARING.pdf", "_blank"), children: t("formFields.privacyStatement") }), t("formFields.and"), " "] }) }) })] }), _jsx(PButton, { endIcon: _jsx(ArrowRight, { size: "16px" }), fullWidth: true, color: "ePrimary", sx: { mb: 1 }, onClick: handleSubmit(onSubmit), disabled: status === APIStatus.PENDING, children: t("actions.sendQuestion") })] }) })] }));
};
